module.exports = __webpack_public_path__ + "static/media/DC_O_Jacquard_City Life_Bordeaux_PW Pink.ae6cbd8b.png";